// Read the company / sender address from environment variables with fallbacks.
export const COMPANY = {
  name:        process.env.REACT_APP_COMPANY_NAME    || "Lineacraft India",
  senderName:  process.env.REACT_APP_SENDER_NAME    || "Shuvasis Sarkar",
  address:     process.env.REACT_APP_COMPANY_ADDRESS || "Bolpur Rabindra Pally, Birbhum",
  city:        process.env.REACT_APP_COMPANY_CITY    || "Bolpur",
  state:       process.env.REACT_APP_COMPANY_STATE   || "West Bengal",
  pincode:     process.env.REACT_APP_COMPANY_PINCODE || "731204",
  phone:       process.env.REACT_APP_COMPANY_PHONE   || "+91 8900658130",
  email:       process.env.REACT_APP_COMPANY_EMAIL   || "lineacraftindia@gmail.com",
  gst:         (process.env.REACT_APP_COMPANY_GST || "").trim() || "19AAACL1234A1Z5",
  driveFolder: process.env.REACT_APP_GOOGLE_DRIVE_FOLDER || "https://drive.google.com/drive/folders/1hVSBe35kV559UiHkaI1fsMTnPbDyc5Pm?usp=sharing",
  driveFolderId: "1hVSBe35kV559UiHkaI1fsMTnPbDyc5Pm",
};

export const isGstConfigured = () => Boolean(COMPANY.gst && COMPANY.gst.trim());

